import React from "react";

export function CheckboxOld(props) {

    return (
        <div className="myCheckbox list-inline-item ml-5 mr-2 mt-1">
            <input id={props.label} autoComplete="off" name={props.name} type="checkbox"
                   value={props.label}
                   checked={props.checked || false} onChange={props.onChange}/>
            <label htmlFor={props.label} className="btn btn-light">
                <i className="fa fa-check"/>
                <i className="fa fa-remove"/>
                {props.label}
            </label>
        </div>
    );
}

export function Ratio(props) {
    return (
        <div className="myCheckbox list-inline-item ml-5 mr-2 mt-1">
            <input id={props.label} autoComplete="off" name={props.name} type="radio"
                   value={props.label}
                   checked={props.checked || false} onChange={props.onChange}/>
            <label htmlFor={props.label} className="btn btn-light">
                <i className="fa fa-circle"/>
                <i className="fa fa-circle-o"/>
                {props.label}
            </label>
        </div>
    );
}

export const Checkbox = ({
                      field: { name, value, onChange, onBlur },
                      form: { errors, touched, setFieldValue },
                      id,
                      label,
                      className,
                      ...props
                  }) => {
    return (
        <div className="myCheckbox list-inline-item ml-5 mr-2 mt-1">
            <input
                autoComplete="off"
                name={name}
                id={id}
                type="checkbox"
                value={value}
                checked={value}
                onChange={onChange}
                onBlur={onBlur}
            />
            <label htmlFor={id} className="btn btn-light">
                <i className="fa fa-check"/>
                <i className="fa fa-remove"/>
                {label}
            </label>
        </div>
    );
};